import { useQuery } from "@apollo/client";
import { useSalonStore } from "@/lib/store/salon";
import { CALENDAR_WORKERS_QUERY } from "../graphql/calendar";

export const useCalendarWorkers = () => {
  const { currentSalon } = useSalonStore();

  const { data, loading, error, refetch } = useQuery(CALENDAR_WORKERS_QUERY, {
    variables: {
      salonId: currentSalon?.id ?? "",
      filters: {
        isActive: true,
      },
    },
    skip: !currentSalon?.id,
    fetchPolicy: "cache-first",
  });

  return {
    workers: data?.workers?.workers || [],
    loading,
    error,
    refetch,
  };
};
